import { render, staticRenderFns } from "./EspeciesTabAnaliseDeRisco.vue?vue&type=template&id=63327f66&"
import script from "./EspeciesTabAnaliseDeRisco.vue?vue&type=script&lang=js&"
export * from "./EspeciesTabAnaliseDeRisco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports